import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import GameInterface from './index';
import store from '../../state/store';
import { setSpinEvent } from '../../state/slices/spinEvent/spinEvent';
import SPIN_PHASE from './helpers/spinPhases';
import utils from '../../utils';
import { PLATFORM } from '../../constants';
var Konami = /*#__PURE__*/function (_GameInterface) {
  /**
   * GameInterface constructor
   * @param {Object} args
   * @param {import("../Constants").BetInfo} args.BetInfo
   * @param {Function} args.ExitFunc
   */
  function Konami(args) {
    var _this;
    _classCallCheck(this, Konami);
    _this = _callSuper(this, Konami, [args]);
    /**
     * Konami Event Handler
     * @param {import("./helpers/parseEvent").ParsedEvent} event
     */
    _this.jsonParserEvent = function (payload) {
      var _store$getState$playe = store.getState().playerInfo,
        playerId = _store$getState$playe.playerId,
        soundEffects = _store$getState$playe.soundEffects;
      var gameId = store.getState().gameInfo.gameId;
      if (soundEffects !== _this.currentSoundSetting) {
        _this.setSound();
      }
      switch (payload.event) {
        case 'loaded':
          // some spin games send multiple gameLoaded events
          _this.setSound();
          _this._gameReady();
          _this.sendAnalyticEvent();
          break;
        case 'round_start':
          // This event fires after the round_init and round_result events, and before round_complete
          break;
        case 'round_wager':
          if (payload.wager) {
            store.dispatch(setSpinEvent({
              playerId: playerId,
              createdTimestamp: Date.now(),
              spinPhase: SPIN_PHASE.WAGE,
              amount: payload.wager,
              gameId: gameId,
              balanceBefore: payload.balance
            }));
            var wager = parseInt(payload.wager);
            _this.DebitCoins(wager);
            _this.AddSpinXP(wager);
            _this._currentBet = wager;
          }
          break;
        case 'round_result':
          if (payload.win && payload.win > 0) {
            var win = parseInt(payload.win);
            store.dispatch(setSpinEvent({
              playerId: playerId,
              createdTimestamp: Date.now(),
              spinPhase: SPIN_PHASE.WIN,
              gameId: gameId,
              amount: win
            }));
            _this.SetLastWin(win);
            _this._lastWinRound = _this._currentRound;
          }
          break;
        case 'round_complete':
          // round_complete event fires after the game animation completes and once the win (if any) is actually displayed in game
          store.dispatch(setSpinEvent({
            balanceAfter: payload.balance
          }));
          _this.syncCoinsBalance(payload.balance);
          var lastWin = _this.GetLastWin();
          if (lastWin !== 0 && _this._currentRound === _this._lastWinRound) {
            _this.CreditCoins(lastWin);
            if (lastWin >= 10 * _this._currentBet && !utils.isWebOrMobileWeb()) _this.showRateUsScreen();
          }
          break;
        case 'out_of_credits':
          _this._outOfCoins();
          _this.showOutOfCoinsScreen();
          break;
        case 'error' || 'fatal':
          var errorDescription = JSON.stringify(payload);
          _this.sendErrorCreatedEvent(errorDescription);
          break;
        default:
          break;
      }
    };
    _this._currentRound = 0;
    _this._lastWinRound = 0;
    _this._currentBet = 0;
    _this.currentSoundSetting = false;
    return _this;
  }
  _inherits(Konami, _GameInterface);
  return _createClass(Konami, [{
    key: "setSound",
    value: function setSound() {
      var soundEffects = store.getState().playerInfo.soundEffects;
      this.sendEvent(JSON.stringify({
        event: 'volume',
        volume: soundEffects
      }));
      this.currentSoundSetting = soundEffects;
    }
  }]);
}(GameInterface);
export default Konami;